import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ThemeProvider } from "./components/ThemeProvider";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import StickyMobileCTA from "./components/StickyMobileCTA";
import { Toaster } from "sonner";

import Home from "./pages/Home";
import DestinationList from "./pages/DestinationList";
import DestinationDetail from "./pages/DestinationDetail";
import Experiences from "./pages/Experiences";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogPostDetail from "./pages/BlogPostDetail";
import Testimonials from "./pages/Testimonials";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";

// Admin
import AdminLayout from "./components/admin/AdminLayout";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminInquiries from "./pages/admin/Inquiries";
import AdminBlogList from "./pages/admin/BlogList";
import AdminBlogEdit from "./pages/admin/BlogEdit";
import AdminTestimonials from "./pages/admin/Testimonials";
import AdminNewsletter from "./pages/admin/Newsletter";
import AdminDestinations from "./pages/admin/Destinations";
import AdminPackages from "./pages/admin/Packages";
import AdminSettings from "./pages/admin/Settings";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function PublicShell({ children }) {
  return (
    <>
      <Navbar />
      <main className="pb-16 md:pb-0">{children}</main>
      <Footer />
      <FloatingWhatsApp />
      <StickyMobileCTA />
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Admin routes — own layout */}
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="inquiries" element={<AdminInquiries />} />
              <Route path="destinations" element={<AdminDestinations />} />
              <Route path="packages" element={<AdminPackages />} />
              <Route path="blog" element={<AdminBlogList />} />
              <Route path="blog/new" element={<AdminBlogEdit />} />
              <Route path="blog/:id" element={<AdminBlogEdit />} />
              <Route path="testimonials" element={<AdminTestimonials />} />
              <Route path="newsletter" element={<AdminNewsletter />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>

            {/* Public site */}
            <Route path="/" element={<PublicShell><Home /></PublicShell>} />
            <Route path="/destinations" element={<PublicShell><DestinationList /></PublicShell>} />
            <Route path="/destinations/:slug" element={<PublicShell><DestinationDetail /></PublicShell>} />
            <Route path="/experiences" element={<PublicShell><Experiences /></PublicShell>} />
            <Route path="/about" element={<PublicShell><About /></PublicShell>} />
            <Route path="/contact" element={<PublicShell><Contact /></PublicShell>} />
            <Route path="/journal" element={<PublicShell><Blog /></PublicShell>} />
            <Route path="/journal/:slug" element={<PublicShell><BlogPostDetail /></PublicShell>} />
            <Route path="/testimonials" element={<PublicShell><Testimonials /></PublicShell>} />
            <Route path="/privacy" element={<PublicShell><Privacy /></PublicShell>} />
            <Route path="/terms" element={<PublicShell><Terms /></PublicShell>} />
          </Routes>

          <Toaster
            position="bottom-right"
            theme="system"
            toastOptions={{
              style: { background: "hsl(var(--background))", color: "hsl(var(--foreground))", border: "1px solid hsl(var(--border))", borderRadius: 0 },
            }}
          />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
